import z from 'zod';
import { SalesOrderHistoryEntrySchema } from './SalesOrderHistoryEntry';

export const SalesOrderHistoryResultSchema = z.object({
    data: z.array(SalesOrderHistoryEntrySchema),
    total: z.number(),
});

export type SalesOrderHistoryResult = z.infer<typeof SalesOrderHistoryResultSchema>;
